export const applyAppraisalTemplate = (appraisal, templateDescription) => {
  if (!appraisal) return templateDescription;

  return `${appraisal} ${templateDescription}`.trim();
};
